module.exports = __webpack_public_path__ + "img/517.e6e4188d.jpg";